import ApiGateway from '../../aws/api-gateway/ApiGateway';
import { Sources } from '../sourceSettings';
const debug = process.env.REACT_APP_DEBUG && false;
const deviceMetricsQueryPath = 'deviceBucketedMetrics';
const source = Sources.S3Athena;
const pathPrefix = source === Sources.S3Athena ? 'bi' : 'timestream';
export const geDeviceMetrics = async ({ duration, units, sortOrder, fromDateValue, toDateValue, deviceSks, NextToken, }) => {
    const path = `/${pathPrefix}/${deviceMetricsQueryPath}`;
    const params = {
        duration,
        units,
        sortOrder,
        fromTimestampMs: fromDateValue.unix() * 1000,
        toTimestampMs: toDateValue.unix() * 1000,
        deviceSks,
        NextToken,
    };
    let res = { err: null, data: null };
    const queryRes = (await ApiGateway.post(path, params, 'NetworkApi'));
    if (queryRes.err) {
        res.err = queryRes.err;
    }
    if (queryRes.NextToken) {
        res.NextToken = queryRes.NextToken;
    }
    if (queryRes.data) {
        res.data = queryRes.data;
        debug && console.log('Device metrics data', queryRes);
    }
    return res;
};
const maxIterations = 100;
export const iterateGetDeviceMetrics = async (iteration = 0, queryRequest, previousRes = { err: null, data: null, NextToken: undefined }) => {
    const { duration, units, sortOrder, deviceSks, fromDateValue, toDateValue, NextToken: NextTokenIn } = queryRequest;
    const { err: iterationErr, data: iterationData, NextToken, } = await geDeviceMetrics({ duration, units, sortOrder, deviceSks, fromDateValue, toDateValue, NextToken: NextTokenIn });
    if (iterationErr) {
        debug && console.log('iterateGetDeviceMetrics err', iterationErr?.message);
        previousRes.err = iterationErr;
    }
    else if (iterationData) {
        previousRes.data = [...(previousRes.data ?? []), ...iterationData];
        if (NextToken) {
            if (iteration < maxIterations) {
                if (iterationData?.length === 0) {
                    console.log(`API returned zero results but a NextToken`);
                }
                previousRes = await iterateGetDeviceMetrics(iteration + 1, { ...queryRequest, NextToken }, previousRes);
            }
            else {
                console.log(`iterateGetDeviceMetrics sreached max iterations ${maxIterations}`);
            }
        }
    }
    return previousRes;
};
